import { makeStyles } from "@material-ui/core";
import transaction from "../../../api/transaction";
const drawerWidth = 240;

export default makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  logoWrapper: {
    display: "flex",
    alignItems: "center",
    padding: "8px 16px",
    margin: "24px 0",
  },
  logoIcon: {
    "& img": {
      height: "36px",
    },
  },
  logoText: {
    "& img": {
      height: "19px",
      marginLeft: "16px",
    },
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.palette.transition3,
    "&.MuiDrawer-paperAnchorRight": {
      height: "100%",
      boxShadow: "-3px -3px 6px rgba(0,0,0,0.1) inset",
      borderRight: "none",
      background: theme.palette.background.sidebar,
    },
  },
  drawerClose: {
    transition: theme.palette.transition3,
    overflowX: "hidden",
    width: "68px",
    [theme.breakpoints.up("sm")]: {
      width: "68px",
    },
    "&.MuiDrawer-paperAnchorRight": {
      height: "100%",
      boxShadow: "-3px -3px 6px rgba(0,0,0,0.1) inset",
      borderRight: "none",
      background: theme.palette.background.sidebar,
    },
  },
  // drawerOver: {
  //   position: "fixed",
  //   zIndex: "9999",
  //   top: "0",
  //   left: "0",
  //   bottom: "0",
  //   "& .MuiDrawer-paperAnchorRight": {
  //     boxShadow: "3px 3px 6px rgba(0,0,0,0.1) ",
  //   },
  //   "& $drawerClose": {
  //     "&.MuiDrawer-paperAnchorRight": {
  //       background: theme.palette.background.sidebar,
  //     },
  //   },
  //   "& $drawerOpen": {
  //     "&.MuiDrawer-paperAnchorRight": {
  //       background: theme.palette.background.sidebarOver,
  //     },
  //   },
  // },
  MenuItemsText: {
    color: theme.palette.secondary.tint60,
  },
  drawerBottom: {
    display: "flex",
    fontSize: theme.fontSize["20"],
    color: theme.palette.secondary.tint40,
    padding: "16px",
    marginTop: "32px",
    cursor: "pointer",
    justifyContent: "center",
    minHeight: "54px",
    position: "absolute",
    bottom: "0",
    left: "0",
    right: "0",
  },
  drawerBottomOpen: {
    justifyContent: "flex-end",
    "& $drawerBottomIcon": {
      marginLeft: "6px",
    },
  },
  drawerBottomIcon: {
    display: "flex",
    alignItems: "center",
  },
  listItemWrapper: {
    padding: "8px 24px",
    minHeight: "44px",
    "& .MuiListItemIcon-root": {
      minWidth: "44px",
      color: theme.palette.secondary.tint60,
    },
  },
  icons: {
    fontSize: theme.fontSize["20"],
  },
  selected: {
    color: theme.palette.primary.main,
  },
}));
